import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.palette.secondary.dark,
  padding: theme.spacing(12),
  userSelect: 'none',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const AvatarContainer = styled(Flex)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  width: 40,
  height: 40,
  borderRadius: '100%',
  overflow: 'hidden',
  justifyContent: 'center',
  alignItems: 'center',
}));
